import { FC, useRef, useEffect } from "react";
import styles from "./OpacityPopup.module.css";

interface Props {
  opacity: number;
  onChange: (v: number) => void;
  onClose: () => void;
}

export const OpacityPopup: FC<Props> = ({ opacity, onChange, onClose }) => {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        document.addEventListener("click", (ce) => ce.stopPropagation(), { capture: true, once: true });
        onClose();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [onClose]);

  return (
    <div ref={ref} className={styles.popup}>
      <span className={styles.label}>Opacity</span>
      <div className={styles.row}>
        <input
          type="range"
          min={0}
          max={100}
          value={opacity}
          onChange={(e) => onChange(Number(e.target.value))}
          className={styles.slider}
        />
        <span className={styles.value}>{opacity}%</span>
      </div>
    </div>
  );
};
